import React from "react";
import "./MemoryPanel.css";

/**
 * Read-only view of the active environment's shared memory. Lists what the
 * agent has remembered (path + content). No editing for now.
 */
export default function MemoryPanel({ memories, loading, error, onRefresh }) {
  return (
    <div className="ca-memory">
      <div className="ca-memory-head">
        <span className="ca-memory-hint">
          Shared preferences the agent remembers for this environment.
        </span>
        <button className="ca-memory-refresh" onClick={onRefresh} disabled={loading}>
          {loading ? "…" : "Refresh"}
        </button>
      </div>
      {error && <div className="ca-memory-error">Couldn't load memory.</div>}
      {!error && !loading && memories.length === 0 && (
        <div className="ca-memory-empty">
          Nothing remembered yet — preferences you mention in chats will show up here.
        </div>
      )}
      <ul className="ca-memory-list">
        {memories.map((m) => (
          <li key={m.id} className="ca-memory-item">
            {m.path && <div className="ca-memory-path">{m.path}</div>}
            <div className="ca-memory-content">{m.content || ""}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
